import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './DemoTimeline.module.css';

function formatDate(value) {
  if (!value) return '';
  const date = new Date(String(value).replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', hour: '2-digit', minute: '2-digit' });
}

function Item({ status, title, text, steps }) {
  return (
    <li className={`${styles.item} ${styles[status]}`}>
      <span className={styles.marker}>
        {status === 'done' && <CheckCircleIcon fontSize="small" />}
        {status === 'failed' && <ErrorOutlineIcon fontSize="small" />}
        {status === 'active' && <CircularProgress size={16} thickness={5} />}
      </span>
      <div>
        <strong className={styles.title}>{title}</strong>
        {text && <p className={styles.text}>{text}</p>}
        {steps && (
          <ol className={styles.steps}>
            {steps.map((step, index) => <li key={index}>{step}</li>)}
          </ol>
        )}
      </div>
    </li>
  );
}

/**
 * Andamento do teste: agendamento criado, mensagem enviada, resposta da pessoa.
 * Com a mensagem entregue, a resposta vira o passo a passo do que fazer no celular.
 */
function DemoTimeline({ state, waiting, sender }) {
  const confirmed = ['confirmed', 'confirmed_by_patient'].includes(state.status);
  const canceled = state.status === 'canceled_by_patient';
  const failed = state.message_status === 'failed';
  const sent = state.message_status === 'sent' || confirmed || canceled;

  let answer = { status: 'pending', title: 'Sua resposta', text: 'Toque em um dos botões da mensagem.' };
  if (confirmed) {
    answer = {
      status: 'done',
      title: 'Presença confirmada',
      text: 'Pronto: a agenda já mostra o atendimento como confirmado. É assim com cada pessoa que responde à confirmação.',
    };
  } else if (canceled) {
    answer = {
      status: 'done',
      title: 'Você respondeu que não vai',
      text: 'Com um agendamento de verdade, o horário fica livre na agenda e o aviso aparece no sino.',
    };
  } else if (sent && waiting) {
    answer = {
      status: 'active',
      title: 'Agora é com você: confirme pelo WhatsApp',
      text: null,
      steps: [
        <>Abra no seu celular a mensagem {sender ? <>de <strong>{sender}</strong></> : 'que acabou de chegar'}.</>,
        <>Toque no botão <strong>Confirmar presença</strong>.</>,
        'Pronto: esta tela muda sozinha em segundos, sem precisar recarregar.',
      ],
    };
  }

  return (
    <ol className={styles.timeline}>
      <Item status="done" title="Atendimento de teste marcado" text={formatDate(state.date)} />
      <Item
        status={failed ? 'failed' : sent ? 'done' : 'active'}
        title={failed ? 'A mensagem não saiu' : sent ? 'Mensagem enviada para o seu WhatsApp' : 'Enviando a mensagem...'}
        text={failed ? 'Confira o número abaixo e envie de novo.' : null}
      />
      {!failed && <Item {...answer} />}
    </ol>
  );
}

export default DemoTimeline;
